import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import autocompleteService from '../../common/api/autocompleteService';
import { LOADING_STATUS } from '../../common/constants';

export interface AutoSuggestOption {
  value: string;
  label: string;
  type: string;
  isParent: boolean;
  description?: string;
}

export interface AutoSuggestActionMeta {
  action?: string;
  prevInputValue?: string;
}

export interface AutoSuggestionItem {
  id: string;
  name: string;
  type: string;
  isParent: boolean;
  description: string;
}

interface AutoCompleteState {
  suggestions: AutoSuggestionItem[];
  loading: LOADING_STATUS.IDLE | LOADING_STATUS.LOADING | LOADING_STATUS.FAILED;
}

const initialState: AutoCompleteState = {
  suggestions: [],
  loading: LOADING_STATUS.IDLE,
};

export const fetchAutoSuggestions = createAsyncThunk(
  'autocomplete/fetchAutoSuggestions',
  async (
    { prefix, locale }: { prefix: string; locale: string },
    { rejectWithValue },
  ) => {
    try {
      return await autocompleteService.getAutoSuggestions(prefix, locale);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

const autocompleteSlice = createSlice({
  name: 'autocomplete',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchAutoSuggestions.pending, state => {
        state.loading = LOADING_STATUS.LOADING;
      })
      .addCase(fetchAutoSuggestions.fulfilled, (state, action) => {
        state.loading = LOADING_STATUS.IDLE;
        state.suggestions = action.payload;
      })
      .addCase(fetchAutoSuggestions.rejected, (state, action) => {
        state.loading = LOADING_STATUS.FAILED;
      });
  },
});

export default autocompleteSlice.reducer;
